import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';
import { getMessage } from '@gef-ui/localization/messages';
import Bizmachine from '@gef-ui/material-icons/Bizmachine';

import ComponentLoader from 'components/molecules/ComponentLoader';
import { KCL_DISPLAY_PROSPECTOR_LINK } from 'features/common/acl/constants';
import fetch from 'features/common/fetch';
import { urls } from 'features/common/fetch/constants';

export const ProspectorButton = ({ businessIn }) => {
	const dispatch = useDispatch();

	const userIsFopOrPo = !isNilOrEmpty(businessIn);
	const hasDisplayProspectorLinkPerm = useSelector((state) => hasPermissionByIds(state)(KCL_DISPLAY_PROSPECTOR_LINK));
	const showButton = userIsFopOrPo && hasDisplayProspectorLinkPerm;

	const handleOpenProspector = useCallback(() => {
		// window set before the async fn - workaround for opening new window in iOS devices
		const win = window.open();
		dispatch(
			fetch.actions.get(urls.prospector, {
				replaceParams: { nationalIn: businessIn },
			}),
		)
			.then((response) => {
				const { url } = response.body;
				win.location.href = url;
			})
			.catch((error) => {
				console.error(error);
			});
	}, [dispatch, businessIn]);

	return (
		showButton && (
			<ComponentLoader fetchStorePath={urls.prospector} ignoreErrors>
				<Button variant="text" size="small" startIcon={<Bizmachine />} onClick={handleOpenProspector}>
					{getMessage('detail:asideBarButtonProspector')}
				</Button>
			</ComponentLoader>
		)
	);
};

ProspectorButton.propTypes = {
	businessIn: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ProspectorButton;
